export default "__VITE_ASSET__s_E1QXHf__"